export const QUOTE_PRODUCTS_ALREADY_EXIST = 'quote_products_already_exist'
export const GENERIC_APPROVE_ERROR = 'An unexpected error occurred, please try again later or contact our support'

interface ApiErrorLike {
  response?: {
    status?: number;
    data?: {
      message?: unknown;
      error_code?: unknown;
    };
  };
}

/**
 * The approve endpoint answers one known, user-actionable case (a "new product"
 * SKU that already exists in the catalog) with a 422 carrying a stable
 * error_code. Only that response's message is shown verbatim; every other
 * failure keeps the generic toast, so arbitrary backend text never reaches the
 * screen.
 */
export default function quoteApproveErrorMessage (error: unknown): string {
  const response = (error as ApiErrorLike | undefined)?.response
  const data = response?.data

  if (
    response?.status === 422 &&
    data?.error_code === QUOTE_PRODUCTS_ALREADY_EXIST &&
    typeof data.message === 'string' &&
    data.message !== ''
  ) {
    return data.message
  }

  return GENERIC_APPROVE_ERROR
}
